import Vue from 'vue'
import Vuex from 'vuex'
import { store as CommonsStore } from 'commons'

const state = {
  ...CommonsStore.state,
  menuAlias: '',
  contentLoading: true
}

const mutations = {
  ...CommonsStore.mutations,
  scroll (state, pos = {x: 0, y: 0}) {
    document.documentElement.scrollTo && document.documentElement.scrollTo(pos.x, pos.y)
    window.scrollTo && window.scrollTo(pos.x, pos.y)
  }
}

const actions = {
  ...CommonsStore.actions
}

const getters = {
  ...CommonsStore.getters
}

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js